import * as React from 'react';
import { EPageTypes, EPlatformTypes, SimpleCall } from '@cian/frontend-newbuilding-call-component';
import { IconCommunicationPhone16 } from '@cian/ui-kit-design-tokens/icons';
import { useSelector } from 'react-redux';

import { BuilderOffersNotAvailableBlock } from '../../components/BuilderOffersNotAvailableBlock';
import { getBuilders, getNewbuildingId, getSellers } from '../../selectors/newbuilding';
import { setUserOpenedPhoneInNewobject } from '../../utils/lastHopePopup';
import { useApplicationContext } from '../../utils/withApplicationContext';

const CALL_BUTTON_TEXT = 'Контакты застройщика';

export const BuilderOffersNotAvailable = () => {
  const { httpApi, logger } = useApplicationContext();

  const builders = useSelector(getBuilders);
  const sellers = useSelector(getSellers);
  const newbuildingId = useSelector(getNewbuildingId);

  const handleShowPhone = React.useCallback(() => {
    setUserOpenedPhoneInNewobject(newbuildingId);
  }, [newbuildingId]);

  return (
    <BuilderOffersNotAvailableBlock
      contactButton={
        <SimpleCall
          builders={builders}
          sellers={sellers}
          openContactsStyles={{ size: 'XS' as const }}
          showPhoneStyles={{
            size: 'XS' as const,
            beforeIcon: <IconCommunicationPhone16 color="icon-inverted-default" />,
          }}
          httpApi={httpApi}
          logger={logger}
          onShowPhoneClick={handleShowPhone}
          pageType={EPageTypes.NewbuildingCard}
          platformType={EPlatformTypes.WebDesktop}
          placeType="blockBuilderCallReasons"
          singlePhoneButtonText={CALL_BUTTON_TEXT}
          multiplePhoneButtonText={CALL_BUTTON_TEXT}
        />
      }
    />
  );
};
